// extracted by mini-css-extract-plugin
module.exports = {"m-menu":"TopBarMenuMobile_m-menu_3Yeqw","trigger":"TopBarMenuMobile_trigger_3OzIl"};